import { render, staticRenderFns } from "./scc-notifier.vue?vue&type=template&id=701a54a4&"
import script from "./scc-notifier.vue?vue&type=script&lang=js&"
export * from "./scc-notifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports